const restHost = 'https://jks-cs.dev.e-fork.net',
  restHostBackend = 'https://jks-cs.dev.e-fork.net',
  graphQlEndpoint = '/graphql',
  drupalFormat = 'YYYY-MM-DDTHH:mm:ss',
  self = 'https://jks.dev.e-fork.net';

export { restHost, restHostBackend, graphQlEndpoint, self, drupalFormat };
